import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaTimes, FaPhone, FaWhatsapp, FaMapMarkerAlt, FaEnvelope } from 'react-icons/fa';

const ContactPopup = ({ isOpen, onClose }) => {
  const contactInfo = {
    address: "Sar-e-pul Bus Stop, Shaheed Mazari Road, Kabul, Afghanistan",
    phone: "+93 78 281 8883",
    whatsapp: "+93 78 281 883",
    email: "safirtheelite@gmail.com"
  };

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent("Hello! I'm interested in enrolling in your courses. Could you please provide more information?");
    window.open(`https://wa.me/${contactInfo.whatsapp.replace(/\s+/g, '')}?text=${message}`, '_blank');
  };

  const handlePhoneClick = () => {
    window.open(`tel:${contactInfo.phone}`, '_self');
  };

  const handleEmailClick = () => {
    window.open(`mailto:${contactInfo.email}?subject=Course Enrollment Inquiry`, '_self');
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Backdrop */}
          <motion.div
            className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
          >
            {/* Modal */}
            <motion.div
              className="bg-white rounded-lg shadow-2xl max-w-md w-full p-6 relative"
              initial={{ scale: 0.7, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.7, opacity: 0 }}
              transition={{ type: "spring", stiffness: 300, damping: 30 }}
              onClick={(e) => e.stopPropagation()}
            >
              {/* Close Button */}
              <button
                onClick={onClose}
                className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
              >
                <FaTimes size={20} />
              </button>

              {/* Header */}
              <div className="text-center mb-6">
                <h2 className="text-2xl font-bold text-safir-dark mb-2">Contact Us to Enroll</h2>
                <p className="text-gray-600">Get in touch with us to start your learning journey</p>
              </div>

              {/* Contact Options */}
              <div className="space-y-4">
                {/* WhatsApp */}
                <motion.button
                  onClick={handleWhatsAppClick}
                  className="w-full flex items-center p-4 bg-green-50 hover:bg-green-100 rounded-lg border border-green-200 transition-colors group"
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  <FaWhatsapp className="text-green-600 text-xl mr-4" />
                  <div className="text-left">
                    <div className="font-semibold text-gray-800">WhatsApp</div>
                    <div className="text-sm text-gray-600">{contactInfo.whatsapp}</div>
                  </div>
                </motion.button>

                {/* Phone */}
                <motion.button
                  onClick={handlePhoneClick}
                  className="w-full flex items-center p-4 bg-blue-50 hover:bg-blue-100 rounded-lg border border-blue-200 transition-colors group"
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  <FaPhone className="text-blue-600 text-xl mr-4" />
                  <div className="text-left">
                    <div className="font-semibold text-gray-800">Phone</div>
                    <div className="text-sm text-gray-600">{contactInfo.phone}</div>
                  </div>
                </motion.button>

                {/* Email */}
                <motion.button
                  onClick={handleEmailClick}
                  className="w-full flex items-center p-4 bg-purple-50 hover:bg-purple-100 rounded-lg border border-purple-200 transition-colors group"
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  <FaEnvelope className="text-purple-600 text-xl mr-4" />
                  <div className="text-left">
                    <div className="font-semibold text-gray-800">Email</div>
                    <div className="text-sm text-gray-600">{contactInfo.email}</div>
                  </div>
                </motion.button>

                {/* Address */}
                <div className="flex items-start p-4 bg-gray-50 rounded-lg border border-gray-200">
                  <FaMapMarkerAlt className="text-gray-600 text-xl mr-4 mt-1" />
                  <div className="text-left">
                    <div className="font-semibold text-gray-800">Visit Us</div>
                    <div className="text-sm text-gray-600">{contactInfo.address}</div>
                  </div>
                </div>
              </div>

              {/* Footer */}
              <div className="mt-6 pt-4 border-t border-gray-200 text-center">
                <p className="text-sm text-gray-500">
                  We're here to help you succeed in your educational journey!
                </p>
              </div>
            </motion.div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default ContactPopup;
